import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  getDeviceContent,
  setDevicesDates,
} from "../../../../state/ducks/devices/operations";
import { localized } from "../../../../state/i18n/i18n";
import { AppState } from "../../../../state/store";
import { DateRangePicker } from "../../default-components/date-range-picker/date-range-picker";
import DeviceGraph from "../device-graph/device-graph";
import "./device-content-container.scss";

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setDevicesDates: (dateFrom: Date, dateTo: Date) =>
    setDevicesDates(dateFrom, dateTo)(dispatch),
  fetchDevices: async (dateFrom: Date, dateTo: Date) =>
    (await getDeviceContent(dateFrom, dateTo))(dispatch),
});

const mapStateToProps = (state: AppState) => {
  return {
    dateFrom: state.devicesReducer.dateFrom,
    dateTo: state.devicesReducer.dateTo,
  };
};

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

class DeviceContentContainer extends React.PureComponent<Props> {
  public render() {
    return (
      <div>
        <div
          className={"topContainer justifyContentStart contentTitleContainer"}
        >
          <div className="contentTitle">{localized("Graphs")}</div>
        </div>
        <div className="graphMargin">
          <div className={"displayFlex padding datePicker"}>
            <DateRangePicker
              dateFrom={this.props.dateFrom}
              dateTo={this.props.dateTo}
              dateChanged={this.DateRangeChanged}
            />
          </div>

          <DeviceGraph
            dateFrom={this.props.dateFrom}
            dateTo={this.props.dateTo}
          />
        </div>
      </div>
    );
  }

  private DateRangeChanged = (dateFrom: Date, dateTo: Date) => {
    let fromDate = dateFrom;
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);

    let toDate = dateTo;
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);

    this.props.setDevicesDates(fromDate, toDate);
    this.props.fetchDevices(fromDate, toDate);
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceContentContainer);
